document.addEventListener('alpine:init', () => {
  Alpine.data('productGallery', () => ({
    activeIndex: 0,
    zoomOpen: false,
    zoomIndex: 0,
    touchStartX: 0,

    scrollThumb(i) {
      const thumbs = document.querySelector('.product-gallery__thumbs');
      if (!thumbs) return;
      const thumb = thumbs.querySelectorAll('.product-gallery__thumb')[i];
      if (!thumb) return;
      const thumbLeft = thumb.offsetLeft;
      const thumbWidth = thumb.offsetWidth;
      const stripWidth = thumbs.offsetWidth;
      thumbs.scrollTo({ left: thumbLeft - (stripWidth / 2) + (thumbWidth / 2), behavior: 'smooth' });
    },

    setActive(i) {
      this.activeIndex = i;
      this.scrollThumb(i);
    },

    prevSlide(total) {
      this.activeIndex = (this.activeIndex - 1 + total) % total;
      this.scrollThumb(this.activeIndex);
    },

    nextSlide(total) {
      this.activeIndex = (this.activeIndex + 1) % total;
      this.scrollThumb(this.activeIndex);
    },

    touchStart(e) {
      this.touchStartX = e.touches[0].clientX;
    },

    touchEnd(e, total) {
      const diff = this.touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) {
        diff > 0 ? this.nextSlide(total) : this.prevSlide(total);
      }
    },

    openZoom(index) {
      this.zoomIndex = index;
      this.zoomOpen = true;
      document.body.style.overflow = 'hidden';
      document.body.classList.add('gallery_lightbox-active');
      this.$nextTick(() => window.FocusTrap?.activate(this.$el.querySelector('.product-gallery__lightbox')));
    },

    closeZoom() {
      this.zoomOpen = false;
      document.body.style.overflow = '';
      document.body.classList.remove('gallery_lightbox-active');
      window.FocusTrap?.release();
    },

    prevImage(total) {
      this.zoomIndex = (this.zoomIndex - 1 + total) % total;
    },

    nextImage(total) {
      this.zoomIndex = (this.zoomIndex + 1) % total;
    },
  }));
});

// Variant selection — sync radio changes to hidden id input + update price/sku/stock
(function () {
  const form = document.querySelector('[data-product-form]');
  if (!form) return;

  const variantData = JSON.parse(
    document.getElementById('product-variant-json')?.textContent || 'null'
  );
  if (!variantData) return;

  function getSelectedOptions() {
    const opts = [];
    form.querySelectorAll('[data-option-position]').forEach((group) => {
      const select = group.querySelector('select.product-form__option-input');
      if (select) {
        opts.push(select.value);
        return;
      }
      const checked = group.querySelector('.product-form__option-input:checked');
      if (checked) opts.push(checked.value);
    });
    return opts;
  }

  function findVariant(options) {
    return variantData.find((v) =>
      options.every((opt, i) => v[`option${i + 1}`] === opt)
    ) || null;
  }

  function updateUI(variant) {
    // Hidden id input
    const idInput = form.querySelector('[data-variant-id]');
    if (idInput) idInput.value = variant ? variant.id : '';

    // Price
    const priceEl = document.querySelector('#product-price');
    if (priceEl && variant) {
      const price = formatMoney(variant.price / 100, window.themeSettings?.moneyFormat);
      const compare = variant.compare_at_price && variant.compare_at_price > variant.price
        ? formatMoney(variant.compare_at_price / 100, window.themeSettings?.moneyFormat)
        : null;
      priceEl.innerHTML = compare
        ? `<div class="price price--on-sale"><span class="price__sale">${price}</span><s class="price__compare">${compare}</s></div>`
        : `<div class="price"><span class="price__regular">${price}</span></div>`;
    }

    // Finance calculator — recalc the "from £X/month" estimate for the new variant
    if (variant && window.__waUpdateFinanceEstimate) {
      window.__waUpdateFinanceEstimate(variant.price, variant.compare_at_price > variant.price);
    }

    // Barcode (fall back to SKU when the variant has no barcode)
    const skuEl = document.querySelector('[data-sku]');
    if (skuEl && variant) skuEl.textContent = variant.barcode || variant.sku || '';

    // Pre-order is per variant (out of stock but still sellable), so the wording
    // follows the selection, not the variant the page happened to open on
    const isPreOrder = Boolean(variant && variant.pre_order);

    // Add to cart button
    const btn = form.querySelector('[data-add-to-cart]');
    if (btn) {
      btn.disabled = !variant || !variant.available;
      const addText = isPreOrder && btn.dataset.preorderText
        ? btn.dataset.preorderText
        : btn.dataset.addText;
      btn.textContent = variant && variant.available ? addText : btn.dataset.soldText;
    }

    // Delivery message — delivery-info.liquid renders both the pre-order copy and
    // the cut-off countdown when the product has a mix of variants; swap which
    // one shows. Nothing to do when the product has no pre-order variant at all.
    const preOrderMsg = document.querySelector('[data-delivery-preorder]');
    if (preOrderMsg) {
      preOrderMsg.hidden = !isPreOrder;
      const standardMsg = document.querySelector('[data-delivery-standard]');
      if (standardMsg) standardMsg.hidden = isPreOrder;
    }

    // Gallery — sync to variant's featured image
    if (variant && variant.featured_image) {
      const mediaId = String(variant.featured_image.id);
      // Desktop: scroll grid item into view
      document.querySelectorAll('.product-gallery__grid-item').forEach((item) => {
        if (item.dataset.mediaId === mediaId) {
          item.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      });
      // Mobile: update activeIndex
      const slides = document.querySelectorAll('.product-gallery__mobile-slide');
      slides.forEach((slide, i) => {
        if (slide.dataset.mediaId === mediaId) {
          const gallery = document.getElementById('product-gallery');
          if (gallery && gallery._x_dataStack) {
            gallery._x_dataStack[0].activeIndex = i;
          }
        }
      });
    }
  }

  form.addEventListener('change', (e) => {
    if (!e.target.classList.contains('product-form__option-input')) return;

    const variant = findVariant(getSelectedOptions());
    updateUI(variant);

    if (history.pushState && variant) {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState({}, '', url.toString());
    }
  });
})();

// Share button
document.querySelector('[data-share]')?.addEventListener('click', async () => {
  try {
    await navigator.share({ title: document.title, url: window.location.href });
  } catch {
    navigator.clipboard?.writeText(window.location.href);
  }
});

// Local formatMoney copy — this script runs before app.js in the deferred
// load order, so it can't rely on app.js's module-level formatMoney existing yet.
function formatMoney(amount, format) {
  const formatted = parseFloat(amount || 0).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return (format || "£{{amount}}")
    .replace(/\{\{\s*amount\s*\}\}/, formatted)
    .replace(/\{\{\s*amount_no_decimals\s*\}\}/, String(Math.round(amount || 0)));
}

// Add-to-cart form submission (variant sync is handled by the IIFE above)
class ProductForm {
  constructor(form) {
    this.form = form;
    this.bindEvents();
  }
  bindEvents() {
    this.form.addEventListener('submit', (e) => {
      e.preventDefault();
      const variantId = this.form.querySelector('[data-variant-id]')?.value;
      if (variantId && window.cart) {
        const quantity = parseInt(this.form.querySelector('.quantity-selector__input')?.value || 1);
        const btn = this.form.querySelector('[data-add-to-cart]');
        const properties = {};
        this.form.querySelectorAll('[name^="properties["]').forEach((el) => {
          const match = el.name.match(/^properties\[(.+)\]$/);
          if (match && el.value.trim() !== '') properties[match[1]] = el.value;
        });
        window.cart.addItem(variantId, quantity, btn, properties);
      }
    });
  }
}
const productFormEl = document.querySelector('[data-product-form]');
productFormEl && new ProductForm(productFormEl);

function initQuantitySelectors() {
  document.querySelectorAll('[data-quantity-minus], [data-quantity-plus]').forEach((btn) => {
    if (btn._qaInit) return;
    btn._qaInit = true;
    btn.addEventListener('click', () => {
      const wrap = btn.closest('.quantity-selector');
      const input = wrap?.querySelector('.quantity-selector__input');
      if (!input) return;
      const value = parseInt(input.value) || 1;
      if (btn.hasAttribute('data-quantity-minus') && value > 1) input.value = value - 1;
      if (btn.hasAttribute('data-quantity-plus')) input.value = value + 1;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });
}
initQuantitySelectors();

// Recently-viewed tracking (PDP only — data-product-id here is unambiguous
// since this script only loads on the product template)
if (document.querySelector('[data-product-id]')) {
  const productId = document.querySelector('[data-product-id]')?.dataset.productId;
  if (productId) {
    const viewed = JSON.parse(localStorage.getItem('wa_recently_viewed') || '[]');
    viewed.includes(productId) || viewed.unshift(productId);
    localStorage.setItem('wa_recently_viewed', JSON.stringify(viewed.slice(0, 10)));
  }
}
